import React, { useMemo, useState, useRef, useEffect } from 'react';
import { debounce } from 'lodash';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'atoms';

const Container = styled(Flex)`
	justify-content: center;
	align-items: center;
	position: relative;
	border: 1px solid #d9d9d9;
	border-bottom: 1px solid;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
`;

const Input = styled.input.attrs((props) => ({
	type: 'text',
	placeholder: props.placeholder,
}))`
	border: 0;
	width: 100%;
	padding: 10px;
	padding-top: 9px;
	font-size: 16px;
	font-weight: 300;
	color: #000;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	height: 40px;
	background-color: rgba(0, 0, 0, 0.04);

	&:focus {
		outline: none;
	}
`;

export default function SearchBar(props) {
	const [cleared, setCleared] = useState(true);
	const inputRef = useRef();
	const { onSearch, queryValue = '', style = {}, label = '', ...rest } = props;

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = queryValue;
		}
	}, [queryValue]);

	const handleSearchChange = useMemo(
		() =>
			debounce((event) => {
				setCleared(event.target.value === '');
				onSearch(event.target.value);
			}, 1000),
		[onSearch]
	);

	return (
		<Box>
			{label && (
				<Text fontWeight="600" fontSize="14px" lineHeight="24px">
					{label}
				</Text>
			)}
			<Container style={style}>
				<Input {...rest} ref={inputRef} onChange={handleSearchChange} />
				<Box style={{ fontSize: '16px', position: 'absolute', right: '15px' }}>
					{!cleared ? (
						<CloseOutlined
							onClick={() => {
								inputRef.current.value = '';
								setCleared(true);
								onSearch('');
							}}
						/>
					) : (
						<SearchOutlined />
					)}
				</Box>
			</Container>
		</Box>
	);
}

SearchBar.propTypes = {
	onSearch: PropTypes.func,
	queryValue: PropTypes.string,
	style: PropTypes.object,
	label: PropTypes.string,
};
